"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FALLBACK_IMAGE = exports.ImageStatus = void 0;
var ImageStatus;
(function (ImageStatus) {
    ImageStatus["loading"] = "loading";
    ImageStatus["loaded"] = "loaded";
    ImageStatus["error"] = "error";
})(ImageStatus = exports.ImageStatus || (exports.ImageStatus = {}));
// FALLBACK_IMAGE - an empty 1x1 pixel we provide as an alternative for the native browser broken pixel image
exports.FALLBACK_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
//# sourceMappingURL=consts.js.map